export function getPickupDisplayName(metadata, t) {
    const description = typeof metadata?.description === 'string' ? metadata.description : null
    const name = typeof metadata?.name === 'string' ? metadata.name : null
    return description || name || t('pickupActionChip.fallbackName')
}
